/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Layout from 'components/Layout';
import StepNavigation from 'components/StepNavigation'
import {
    FileModal
} from '@fitinsur/components';
import {
    Content,
} from './styles';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import {
    LoaderContext
} from '@fitinsur/contexts'
import { useGetOperationsAsync, useGetOperationAsync } from '@fitinsur/services/OperationService';
import { useGetDocuments } from 'services/DocumentsService';

export default function QuoteDocument(props) {
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const history = useHistory();
    const [operation, setOperation] = useState({});
    const [documents, setDocuments] = useState([])

    const {
        loading: useGetOperationsAsyncLoading,
        request: useGetOperationsAsyncRequest,
    } = useGetOperationsAsync();

    const {
        loading: useGetOperationLoading,
        request: useGetOperationRequest
    } = useGetOperationAsync(props.match?.params?.idOperation);

    const {
        data: useGetDocumentsData,
        loading: useGetDocumentsLoading,
        error: useGetDocumentsError,
        status: useGetDocumentsStatus,
        request: useGetDocumentsRequest
    } = useGetDocuments(operation?.idOperation);

    useEffect(() => {
        if (useGetDocumentsStatus === 200) {
            setDocuments(useGetDocumentsData?.value
                ?.filter(doc => ![25, 261, 272, 324, 364, 371, 373, 708, 710, 712, 728, 735, 736].includes(doc.idDomain))
                .reverse()
                .map(
                    quoteRequestDocument => ({
                        idDocument: quoteRequestDocument.idDocument,
                        idDomainDescription: quoteRequestDocument.idDomainDescription,
                        idReport: quoteRequestDocument.idReport,
                        idOperation: quoteRequestDocument.idOperation,
                        reportToken: quoteRequestDocument.reportToken,
                        url: quoteRequestDocument.url,
                        fileName: quoteRequestDocument.documentMetadata.fileName
                    })
                )
            )
        }
    }, [useGetDocumentsStatus]);

    useEffect(() => {
        updateIsLoadingStatus(
            useGetOperationsAsyncLoading ||
            useGetDocumentsLoading ||
            useGetOperationLoading
        )
    }, [
        useGetOperationsAsyncLoading,
        useGetDocumentsLoading,
        useGetOperationLoading
    ]);

    useEffect(() => {
        const handleGetOperation = async () => {
            const { data: { value: operation } } = await useGetOperationRequest();
            if (operation?.idDomain === 26) {
                const { data: { value: [operation] } } = await useGetOperationsAsyncRequest(
                    null,
                    { idDomain: [27], idOperationRoot: props.match?.params?.idOperation }
                );
                setOperation(operation);
            } else {
                setOperation(operation);
            }
        }

        handleGetOperation();
    }, []);

    useEffect(() => {
        if (operation?.idOperation) useGetDocumentsRequest()
    }, [operation]);

    return (
        <Layout
            title={"Documento de cotação"}
            subtitle={`${operation?.productName || ""}`}
            idOperation={ operation?.idDomain === 27 ? operation?.idOperationRoot : operation?.idOperation}
            idProduct={operation?.idProduct}
        >
            <Row>
                <Col>
                    <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} idProduct={props.match?.params?.idProduct} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <BrokingSummary
                        history={history}
                        idOperation={props.match?.params?.idOperation}
                        idProduct={props.match?.params?.idProduct}
                        permissions={props.permissions} />
                </Col>
            </Row>

            <Content>
                <FileModal documents={documents} />
            </Content>
        </Layout >
    )
}
